import { TOKEN_CONFIG } from '../config/BattleRoomConstants';

export const normalizeBattleLayerId = (layerId, fallback = TOKEN_CONFIG.LAYERS.TOKEN) => {
  if (typeof layerId !== 'string') {
    return fallback;
  }

  const normalized = layerId.trim().toLowerCase();
  if (!normalized) {
    return fallback;
  }

  switch (normalized) {
    case 'gm':
    case TOKEN_CONFIG.LAYERS.GAMEMASTER:
      return TOKEN_CONFIG.LAYERS.GAMEMASTER;
    case 'tokens':
    case TOKEN_CONFIG.LAYERS.TOKEN:
      return TOKEN_CONFIG.LAYERS.TOKEN;
    case TOKEN_CONFIG.LAYERS.MAP:
      return TOKEN_CONFIG.LAYERS.MAP;
    case TOKEN_CONFIG.LAYERS.OVERLAY:
      return TOKEN_CONFIG.LAYERS.OVERLAY;
    default:
      return normalized;
  }
};

export const getTokenLayerId = (token, fallback = TOKEN_CONFIG.LAYERS.TOKEN) => (
  normalizeBattleLayerId(token?.layer, fallback)
);

export const canViewerSeeBattleLayer = (layerId, isGameMaster = false) => (
  normalizeBattleLayerId(layerId) !== TOKEN_CONFIG.LAYERS.GAMEMASTER || isGameMaster
);

export const canViewerSeeToken = (token, isGameMaster = false) => (
  Boolean(token) && canViewerSeeBattleLayer(getTokenLayerId(token), isGameMaster)
);

export const isTokenOnBattleLayer = (token, layerId) => (
  Boolean(token) && getTokenLayerId(token) === normalizeBattleLayerId(layerId)
);

export const getViewerVisibleTokens = (tokens = [], isGameMaster = false) => (
  tokens.filter((token) => canViewerSeeToken(token, isGameMaster))
);

export const getTokensForBattleLayer = (tokens = [], layerId, isGameMaster = false) => {
  const normalizedLayerId = normalizeBattleLayerId(layerId);

  return tokens.filter((token) => (
    canViewerSeeToken(token, isGameMaster)
    && isTokenOnBattleLayer(token, normalizedLayerId)
  ));
};
